// Accept only inputs that begin with a single `/` followed by a non-`/`-or-`\` byte. This
// rejects `https://`, `//host`, and `/\host` — three shapes a malicious refUrl could use to
// escape the consumer origin. It does NOT do full URL parsing, so callers shouldn't rely on
// it as a complete same-origin check; pair with a producer that only emits trusted paths.
export function isSafeRelativeUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\');
}
